import { MainMenu, ProfileMenu } from 'components';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { selectShowTrialNextStepHint } from 'store/selectors/subscriptions';

import { SidebarWrapper, StyledBurger } from './styled';

const ProfileSidebarMobile = () => {
  const [initialized, setInitialized] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const showTrialNextStepHint = useSelector(selectShowTrialNextStepHint);
  const showTrialNextStepHintRef = useRef(showTrialNextStepHint);
  showTrialNextStepHintRef.current = showTrialNextStepHint;

  useEffect(() => {
    setInitialized(true);
  }, []);

  useEffect(() => {
    if (showTrialNextStepHintRef.current) return;
    if (isOpen && initialized) {
      setIsOpen(false);
    }
  }, [location]);

  useEffect(() => {
    if (showTrialNextStepHint) {
      setIsOpen(true);
    }
  }, [showTrialNextStepHint]);

  return (
    <>
      <StyledBurger isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
        <div />
        <div />
        <div />
      </StyledBurger>
      <SidebarWrapper isOpen={isOpen} $elevate={showTrialNextStepHint}>
        <MainMenu />
        <ProfileMenu />
      </SidebarWrapper>
    </>
  );
};

export default ProfileSidebarMobile;
